export const creativePortfolio = {
  id: 'creative-portfolio',
  version: 2,
  renderer: 'enterprise',
  name: 'Creative Portfolio Modern',
  layout: 'two-column',
  theme: 'modern-teal',
  persona: ['creative'],
  atsLevel: 'C+',
  scoreWeights: {
    ats: 20,
    visual: 50,
    executive: 10,
    student: 20
  },
  sectionOrder: ['personal-info', 'summary', 'projects', 'experience', 'education', 'skills', 'languages', 'certifications'],
  components: {
    header: 'header-creative',
    experience: 'experience-timeline',
    projects: 'projects-cards',
    skills: 'skills-simple-list',
    education: 'education-sidebar'
  },
  metadata: {
    industry: ['Advertising', 'Creative Arts', 'Media Production'],
    companies: ['Vogue', 'Spotify', 'Netflix', 'Vice', 'Conde Nast', 'Wieden+Kennedy'],
    ats: ['Lever', 'Greenhouse'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    columns: 1,
    centeredHeader: true,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    recommendedFor: ['Art Directors', 'Creative Writers', 'Videographers', 'Photographers'],
    avoidFor: ['Software Engineers', 'Investment Bankers', 'Database Administrators'],
    dna: ['Visual-Creative', 'Teal-Highlights', 'Single-Column-Centered', 'Design-Rich', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 85,
      scanningSpeed: 87,
      visualAppeal: 99
    },
    hiringManager: {
      firstImpression: "Vibrant, design-forward professional with custom branding appeal",
      scanningStyle: "Visual search focusing on layout spacing, project names, and photo/portfolio highlights",
      preferredStructure: "Summary, projects, experience, skills, education",
      dislikes: ["Dull text lines", "Lack of portfolio links", "Dull layout structure"]
    },
    strategy: {
      goal: "Hook advertising and agency recruiters with a high-aesthetic centered format",
      focus: "Visual project outcomes, layout breathing room, and creative stack (e.g. Adobe suite)",
      avoid: ["Traditional serif layouts", "Dense text formatting"]
    },
    psychology: {
      coreTraits: ["Creativity", "Innovation", "Vibrancy", "Design-perfection"]
    },
    readingPattern: {
      fPattern: false,
      zPattern: true,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Use creative storytelling adjectives. Highlight branding impact, videography/photography scope, and campaign design ownership.",
      rewriteStyle: "Creative, modern, expressive"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: false,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['education', 'skills', 'languages'],
        main: ['summary', 'projects', 'experience']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '3px',
    '--bullet-style': 'circle',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '14px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2C3E50',
    '--color-text-light': '#7F8C8D'
  }
};
export default creativePortfolio;
